/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Okta_Step5Inputs */



/**
* | output |
* | --- |
* | "Configure attribute mappings and enable provisioning" |
*
* @param {Scim_Setup_Okta_Step5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_okta_step5 = /** @type {((inputs?: Scim_Setup_Okta_Step5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Okta_Step5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren Sie Attributzuordnungen und aktivieren Sie die Bereitstellung")
	return /** @type {LocalizedString} */ ("Configure attribute mappings and enable provisioning")
});